import React, { ReactElement } from "react";

/** A large magnifying glass: the illustration of the investigation prompt (matches the badge of investigated players). */
export default function MagnifierArt(): ReactElement {
  return (
    <svg
      className="magnifier-art"
      viewBox="0 0 150 160"
      role="img"
      aria-label="A magnifying glass"
      focusable="false"
    >
      <defs>
        <linearGradient id="mag-gold" x1="0" x2="1" y1="0" y2="1">
          <stop offset="0" stopColor="#fbe08a" />
          <stop offset="0.5" stopColor="#f0be50" />
          <stop offset="1" stopColor="#a87a1c" />
        </linearGradient>
        <linearGradient id="mag-handle" x1="0" x2="1" y1="0" y2="0">
          <stop offset="0" stopColor="#3b4f66" />
          <stop offset="0.5" stopColor="#5b7490" />
          <stop offset="1" stopColor="#26364a" />
        </linearGradient>
        <radialGradient id="mag-glass" cx="0.35" cy="0.3" r="0.8">
          <stop offset="0" stopColor="#e8f5ff" stopOpacity="0.85" />
          <stop offset="0.6" stopColor="#9ccdf0" stopOpacity="0.45" />
          <stop offset="1" stopColor="#5a9bd0" stopOpacity="0.35" />
        </radialGradient>
      </defs>
      {/* Handle, with a gold ferrule where it meets the rim */}
      <g transform="rotate(-45 100 100)">
        <rect x="92" y="108" width="16" height="48" rx="8" fill="url(#mag-handle)" stroke="#16212f" strokeWidth="2.5" />
        <rect x="88" y="100" width="24" height="14" rx="3" fill="url(#mag-gold)" stroke="#6b4b0c" strokeWidth="2.5" />
      </g>
      {/* Lens and rim */}
      <circle cx="62" cy="62" r="46" fill="url(#mag-glass)" />
      <circle cx="62" cy="62" r="46" fill="none" stroke="url(#mag-gold)" strokeWidth="11" />
      <circle cx="62" cy="62" r="51.5" fill="none" stroke="#6b4b0c" strokeWidth="2" />
      <circle cx="62" cy="62" r="40.5" fill="none" stroke="#6b4b0c" strokeWidth="1.5" opacity="0.6" />
      {/* Shine on the glass */}
      <path d="M36 50 A30 30 0 0 1 56 33" fill="none" stroke="#fff" strokeWidth="5" strokeLinecap="round" opacity="0.85" />
      <circle cx="42" cy="68" r="3" fill="#fff" opacity="0.6" />
    </svg>
  );
}
